<template>
    <div class="ReferralRecord" v-if="RecordData">
        <div class="container-fluid">
            <!--<div class="row">
                <div class="col col-md-12">
                    <button type="button" class="close" v-on:click="CloseRecord"><span>x</span></button>
                    <h2><span>{{ RecordData.Status }}</span></h2>
                    <h1><span>{{ RecordData.CommunityFamily != null ? RecordData.CommunityFamily.Name : RecordData.InqParentNames }}</span> <span class="red" v-if="RecordData.CommunityFamily == null">[Not Linked to Community Family]</span></h1>
                    <h4><span>{{ RecordData.InqTerritory.SubProgram.Name + " (" + RecordData.InqTerritory.Name + ")" }}: </span></h4>
                </div>
            </div>-->
            <div class="row" style="margin-top: 10px;">
                <div class="col">
                    <div class="record-tabs">
                        <span class="d-none d-sm-block">
                            <b-nav>
                                <div v-for="pane in Panes">
                                    <b-nav-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-nav-item>
                                </div>
                            </b-nav>
                        </span>
                        <b-nav>
                            <span class="d-sm-none">
                                <b-nav-item-dropdown :text=changeDropdownName id="mobileDropdown">
                                    <div v-for="pane in Panes">
                                        <b-dropdown-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-dropdown-item>
                                    </div>
                                </b-nav-item-dropdown>
                            </span>
                        </b-nav>
                    </div>
                    <div class="tab-content">
                        <div v-show="PaneShown == 'Summary'">
                            <ReferralSummary v-bind:record-data="RecordData" />
                        </div>
                        <div v-if="PaneShown == 'Family Link'">
                            <CommunityFamilyAssignment v-bind:record-data="RecordData" />
                        </div>
                        <div v-if="PaneShown == 'Operations'">
                            <ReferralOperations v-bind:record-data="RecordData" />
                        </div>
                        <div v-if="PaneShown == 'Hosting'">
                            <hosting v-bind:record-data="RecordData" />
                        </div>
                        <!--<div v-show="PaneShown == 'Family Info'">
                            <Information v-bind:record-data="RecordData" />
                        </div>
                        <div v-show="PaneShown == 'Program'">
                            <Program v-bind:record-data="RecordData" />
                        </div>
                        <div v-show="PaneShown == 'People'">
                            <People v-bind:record-data="RecordData" />
                        </div>
                        <div v-show="PaneShown == 'Log'">
                            <ServiceLog v-bind:record-data="RecordData" />
                        </div>-->
                        <!--<div v-show="PaneShown == 'Admin'">
                            <Admin v-bind:child-record-data="ChildRecordData" />
                        </div>
                        <div v-show="PaneShown == 'Reports'">
                            <Reports v-bind:child-record-data="ChildRecordData" />
                        </div>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import { EventBus } from '../../../../../services/event-bus.js';

    import CommunityFamilyAssignment from './CommunityFamilyAssignment.vue';
    import ReferralSummary from './ReferralSummary.vue';
    import ReferralOperations from './ReferralOperations.vue';
    import Hosting from './Hosting.vue';
    //import Admin from "./Admin.vue";
    //import Audit from "./Audit.vue";
    //import CaseFile from "../../../../Core/RecordComponents/CaseFile.vue";
    
    //import Information from "./Information.vue";
    //import NewDocument from "../../../../Core/RecordComponents/NewDocument.vue";
    //import People from "./People.vue";
    //import Team from "./Team.vue";
    //import Program from "./Program.vue";
    //import ServiceLog from "./ServiceLog.vue";
    //import Reports from "./Reports.vue";
    
    export default {
        name: "ReferralRecord",
        created() {
            let vm = this;
            EventBus.$on('profile-update-needed', chartID => {
                if (chartID == vm.ListData.Id || (vm.RecordData.Id && chartID == vm.RecordData.Id)) {
                    vm.UpdateChartData();
                }
            });

        },
        beforeDestroy() {
            EventBus.$off('profile-update-needed');
        },
        props: [
            "ListData"
        ],
        
        data: function () {
            return {
                RecordData: {},
                PaneShown: "Summary"
            };
        },
        methods: {
            UpdateChartData() {
                this.$MasterAPI.ExecuteRequest("GET", "StrongFamilies/Referrals/" + this.ListData.Id, {}, this.UpdateChartDataSuccess, () => { }, true);
            },
            UpdateChartDataSuccess(response) {
                //this.$store.commit("Clients.ClientEnrollmentsList.ReplaceSingleRecord", response.data.data);
                this.RecordData = response.data.data;
            },
            ChangePaneShown(paneName) {
                this.PaneShown = paneName;
            },
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CloseRecord() {
                this.$parent.CloseRecord("CommunityFamilyReferrals.Profiles.Remove","ReferralList",this.RecordData.Id);
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            CommunityFamilyAssignment,
            ReferralSummary,
            ReferralOperations,
            Hosting
            //Admin,
            //Information,
            //People,
            //Program,
            //ServiceLog,
            //Reports
        },
        mounted() { 
            this.UpdateChartData();
        },
        watch: {
            ListData(newItem, oldItem) {
                if (newItem.Id != oldItem.Id) {
                    this.UpdateChartData();
                }
            }
        },
        computed: {
            Panes: function () {
                if (this.RecordData.CommunityFamily != null) {
                    let initialList = [
                        { name: 'Summary' },
                        
                        { name: 'Operations' },
                        { name: 'Family Link' },
                    ];

                    if (this.RecordData.Status != 'Open Inquiry' && this.RecordData.Status != 'Inquiry Closed') {
                        initialList.push({ name: 'Hosting' });
                    }

                    return initialList;
                } else {
                    return [
                        { name: 'Summary' },
                        { name: 'Operations' },
                        { name: 'Family Link' }
                    ];
                }
            },
            changeDropdownName: function () {
                return this.PaneShown;
            },
            SubProgramFormMemberships: function () {
                //let subProgram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.ChildRecordData.SubProgramID);
                //return subProgram.FormMemberships.filter(fm => fm.ChartType == "ClientSubProgramMembership");
                return [];
            }
        },
    }
</script>

<style scoped>
    .record-tabs {
        width: 100%;
        display: inline-block;
    }
    @media only screen and (max-width: 576px) {
        h4{
        font-size: 1em;
        }
        h1{
        font-size: 1.5em;
        }
    }
    li a{
        color:black !important;
    }
    li.active a {
        color: black !important;
    }
</style>